import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import analyticsService from '../services/analytics.service';

export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view when location changes
    analyticsService.trackPageView(location.pathname + location.search);
  }, [location]);
}; 